import { useParams } from "react-router-dom";

import TrialDocuments from "../../components/Trials/TrialDocuments";

const TrialDocumentsTab = () => {
  const { _id_ } = useParams();

  return <TrialDocuments trialId={_id_} />;
};

export default TrialDocumentsTab;
